import { ReactElement } from 'react'
import {
  IconAlertTriangle,
  IconCheck,
  IconCircleDashed,
  IconDroplet,
  IconActivity,
  IconLock,
  IconPlayerPause,
  IconProgress,
} from '@tabler/icons-react'

import { ValveState } from '@data/device/model/device'

// Shared by every component that renders a valve's software state — the Device Modal's
// Valves tab, the standalone Operate Valves page, and their shared valve card.
export type ValveColor =
  | 'gray'
  | 'green'
  | 'yellow'
  | 'blue'
  | 'orange'
  | 'red'
  | 'teal'

export interface ValveStateMeta {
  label: string
  color: ValveColor
}

export type ValveStateMetaMap = Record<
  ValveState,
  ValveStateMeta
>

export type ValveStateIconMap = Record<
  ValveState,
  ReactElement
>

export const VALVE_STATE_META: ValveStateMetaMap =
  {
    0: {
      label: 'Closed',
      color: 'red',
    },
    1: {
      label: 'Open',
      color: 'green',
    },
    2: {
      label: 'Mid Position',
      color: 'yellow',
    },
    3: {
      label: 'Operating',
      color: 'blue',
    },
    4: {
      label: 'Testing',
      color: 'blue',
    },
    5: {
      label: 'Test Passed',
      color: 'teal',
    },
    6: {
      label: 'Operation Failed',
      color: 'red',
    },
    7: {
      label: 'Not Installed',
      color: 'gray',
    },
  }

export const STATE_ICON: ValveStateIconMap = {
  0: <IconLock size={16} />,
  1: <IconDroplet size={16} />,
  2: <IconPlayerPause size={16} />,
  3: <IconActivity size={16} />,
  4: <IconProgress size={16} />,
  5: <IconCheck size={16} />,
  6: <IconAlertTriangle size={16} />,
  7: <IconCircleDashed size={16} />,
}

export const OPERABLE_STATES: ValveState[] = [0, 1]
